import { render } from "./ClinicCreateTab.vue?vue&type=template&id=32304372"
import script from "./ClinicCreateTab.vue?vue&type=script&lang=js"
export * from "./ClinicCreateTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__